import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const azureDevOps = defineConnector({
  identifier: "azureDevOps",
  name: "Azure DevOps",
  tagLine: "Microsoft DevOps platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://dev\\.azure\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: "",
      password: app.secret.apiToken,
    }),
  steps: [
    {
      title: "Get your Azure DevOps personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "In Azure DevOps, click the **User settings** icon in the top right, select **Personal access tokens**, and create a new token with the scopes you need.",
        },
      ],
    },
    {
      title: "Enter your details",
      items: [
        {
          kind: "input",
          label: "Organization name",
          required: true,
          placeholder: "my-org",
          target: { kind: "configuration", field: "organization" },
          helperText: "Your Azure DevOps organization name.",
        },
        {
          kind: "input",
          label: "Personal access token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ organization }) =>
      `https://dev.azure.com/${organization}/_apis/projects?api-version=7.1`,
  },
});
